import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { DEFAULT_TWO_FACTOR_STRINGS } from '../modules/security';

// İki adımlı doğrulama (madde 12) — giriş ekranı (Login.jsx) ve profil penceresi
// (TwoFactorModal.jsx) ortak parçaları. Bileşenlerin kendisi ortak güvenlik modülünde
// (modules/security/twoFactor.tsx — ServisPro'dan birebir); burada yalnızca uygulamaya özgü
// HTTP, QR çizimi ve İngilizce metinler var.

// JSON POST/GET — hata mesajını (error/message) Error olarak fırlatır.
export async function apiJson(method, url, body, token) {
  const res = await fetch(url, {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || res.statusText);
  return data;
}

/** otpauth:// adresini QR görseli olarak çizer (2FA kurulumu). */
export function QrImage({ text, size = 200 }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(text, { width: size, margin: 1 })
      .then((url) => alive && setSrc(url))
      .catch(() => alive && setSrc(null));
    return () => { alive = false; };
  }, [text, size]);
  if (!src) return null;
  return <img src={src} width={size} height={size} alt="QR" style={{ background: '#fff', padding: 8, borderRadius: 8 }} />;
}

const EN_STRINGS = {
  codeTitle: 'Two-Step Verification',
  codeHintTotp: 'Enter the 6-digit code from your authenticator app (Google/Microsoft Authenticator etc.).',
  codeHintSms: (p) => `Enter the 6-digit code sent to ${p ? `the phone ${p}` : 'your phone'}.`,
  codeHintBackup: "If you can't access your phone, you can enter one of your backup codes (xxxx-xxxx-xxxx-xxxx).",
  codeLabel: 'Verification code',
  verify: 'Verify',
  resend: 'Resend code',
  back: 'Back',
  setupTitle: 'Set Up Two-Step Verification',
  setupIntro: 'A verification code will be required in addition to your password when signing in.',
  methodTotp: 'Authenticator app (recommended)',
  methodSms: 'Code via SMS',
  start: 'Continue',
  totpScan: 'Scan this QR code with your authenticator app, then enter the 6-digit code shown in the app.',
  totpManual: "If you can't scan the QR code, enter this key manually:",
  smsPhoneLabel: 'Mobile phone',
  smsSent: (p) => `A verification code was sent to ${p ?? 'your phone'}.`,
  enable: 'Enable',
  backupTitle: 'Backup Codes',
  backupHint: 'If you lose your phone, you can sign in with these codes. Each code works once. Store them somewhere safe — they will not be shown again.',
  copy: 'Copy',
  copied: 'Copied',
  done: "I've saved them, continue",
  passwordLabel: 'Your password (for confirmation)',
};

export const twoFactorStrings = (lang) => (lang === 'en' ? EN_STRINGS : DEFAULT_TWO_FACTOR_STRINGS);

export const TFA_BUTTONS = { primary: 'auth-btn-primary', secondary: 'auth-btn-google' };
